import React from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { t } from 'react-switch-lang';
import './SelectSearchMulti.scss';
import axios from 'axios';

const SelectSearchMulti = React.forwardRef(
  (
    {
      name,
      className,
      placeholder,
      isMulti,
      value,
      api,
      onChange,
      optionValue,
      optionLabel,
      isSearchable = false,
      searchParams,
      isClearable = false,
      isDisabled,
    },
    ref
  ) => {
    const optionVal = optionValue ?? 'id';
    const optionLab = optionLabel ?? 'name';

    const loadOptions = async (
      search,
      loadedOptions,
      additional = { page: 0, pageSize: 20 }
    ) => {
      const page = additional.page ?? 0;
      const pageSize = additional.pageSize ?? 20;

      try {
        let searchQuery = '';

        if (Array.isArray(searchParams) && search?.trim()) {
          searchParams.forEach((item) => {
            searchQuery += `&${item}=${encodeURIComponent(search)}`;
          });
        }

        const separator = api.includes('?') ? '&' : '?';

        const { data } = await axios.get(
          `${api}${separator}page=${page}&size=${pageSize}${searchQuery}`
        );

        const list = Array.isArray(data) ? data : [];

        return {
          options: list.map((option) => ({
            value: option?.[optionVal],
            label: option?.[optionLab],
          })),
          hasMore: list.length === pageSize,
          additional: {
            page: page + 1,
            pageSize,
          },
        };
      } catch (e) {
        return {
          options: [],
          hasMore: false,
          additional: {
            page,
            pageSize,
          },
        };
      }
    };

    return (
      <AsyncPaginate
        id={name}
        name={name}
        placeholder={placeholder}
        className={className}
        onChange={onChange}
        value={value}
        isMulti={isMulti}
        loadOptions={loadOptions}
        noOptionsMessage={() => t('table.no-data')}
        loadingMessage={() => t('message.loading')}
        debounceTimeout={300}
        additional={{ page: 0, pageSize: 20 }}
        closeMenuOnSelect={!isMulti}
        selectRef={ref}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isDisabled={isDisabled}
      />
    );
  }
);

export default SelectSearchMulti;